/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import { useRouter } from 'next/router';
import { styled } from 'linaria/react';
import { useBreakpoint } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { Spacer } from '@shared/ui/atoms';
interface Props {
  contact: string;
  region?: string;
  icon?: React.ReactElement;
}
const ContactInfo: FC<Props> = ({
  contact,
  region = '',
  icon
}) => {
  const {
    isMobile
  } = useBreakpoint();
  const router = useRouter();
  const isPayQRPage = router.asPath.includes('pay-qr');
  const isPubgGiveawayPage = router.asPath.includes('rozygrysh-prizov-pubg-mobile');
  const isDvoinoiShansNaPobeduPage = router.asPath.includes('dvoinoi-shans-na-pobedu');
  const isOsenniiRozygryshPrizov2026Page = router.asPath.includes('osennii-rozygrysh-prizov-2026');
  const handleClick = value => {
    if (value === '@MTS_Oplata_assist_bot') {
      window.open('https://telegram.me/MTS_Oplata_assist_bot', '_blank');
      return;
    }
    if (value === 'МТС Оплата') {
      window.open('https://max.ru/u/f9LHodD0cOIPl_H6HAGZa7VJVP793h4n73Jc7M-vbqImCpxjCGD3Y-P97vA', '_blank');
      return;
    }
    if (value === 'Написать в чат') {
      window?._upservice?.setState({
        isOpen: true
      });
      return;
    }
    if (!isMobile) return;
    if (value.includes('@') && !value.includes('@MTS_Oplata_assist_bot') && !value.includes('МТС Оплата')) {
      window.location.href = `mailto:${value}`;
    } else {
      window.location.href = `tel:${value}`;
    }
  };
  return <PhoneWrapper isPayQRPage={isPayQRPage} isPubgGiveawayPage={isPubgGiveawayPage} isDvoinoiShansNaPobeduPage={isDvoinoiShansNaPobeduPage} isOsenniiRozygryshPrizov2026Page={isOsenniiRozygryshPrizov2026Page}>
      <div className="region">{region}</div>
      <Spacer space={4} spacemob={4} spacetablet={4} />
      <Wrapper phone={contact}>
        <WrapperIcon>{icon}</WrapperIcon>
        <div style={{
        cursor: 'inherit'
      }} className="phone" onClick={() => handleClick(contact)}>
          {contact}
        </div>
      </Wrapper>
    </PhoneWrapper>;
};
export default ContactInfo;
interface PhoneWrapperProps {
  isPayQRPage: boolean;
  isPubgGiveawayPage: boolean;
  isDvoinoiShansNaPobeduPage: boolean;
  isOsenniiRozygryshPrizov2026Page: boolean;
}
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.footer;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSText;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp8 = /*#__PURE__*/() => ({
  isPayQRPage,
  isPubgGiveawayPage,
  isDvoinoiShansNaPobeduPage,
  isOsenniiRozygryshPrizov2026Page,
  theme
}) => isPayQRPage ? '#969FA8' : isPubgGiveawayPage ? '#BBC1C7' : isDvoinoiShansNaPobeduPage ? '#FFFFFF' : isOsenniiRozygryshPrizov2026Page ? '#FFFFFF' : theme.colors.text.tertiary;
const PhoneWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "PhoneWrapper",
  class: "p1q0g815",
  propsAsIs: false,
  vars: {
    "p1q0g815-0": [_exp()],
    "p1q0g815-1": [_exp2(), "px"],
    "p1q0g815-2": [_exp3()],
    "p1q0g815-3": [_exp4()],
    "p1q0g815-4": [_exp5()],
    "p1q0g815-5": [_exp6(), "px"],
    "p1q0g815-6": [_exp7()],
    "p1q0g815-7": [_exp8()]
  }
}));
const _exp9 = /*#__PURE__*/() => ({
  phone
}) => phone === '@MTS_Oplata_assist_bot' || phone === 'МТС Оплата' || phone === 'Написать в чат' ? 'pointer' : 'inherit';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1iy83rc",
  propsAsIs: false,
  vars: {
    "w1iy83rc-0": [_exp9()]
  }
});
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.footer;
const WrapperIcon = withTheme(/*#__PURE__*/styled('div')({
  name: "WrapperIcon",
  class: "w1c084tr",
  propsAsIs: false,
  vars: {
    "w1c084tr-0": [_exp0()]
  }
}));

require("./ContactInfo.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ContactInfo.tsx");